import { useMemo } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { Button, Card, CardBody } from "reactstrap"
import PreOrderList from "./PreOrder/PreOrderList"
import { usePreOrders } from "hooks/usePreOrder"

export default function PreOrdersTab({ customer, onChanged }) {
  const navigate = useNavigate()
  const location = useLocation()

  const { data, refetch } = usePreOrders(
    { customer_id: customer?.id, all: true },
    !!customer?.id
  )

  const preOrders = useMemo(() => {
    const payload = data?.data
    if (Array.isArray(payload)) return payload
    if (Array.isArray(payload?.data)) return payload.data
    return []
  }, [data])

  const handleChanged = () => {
    refetch()
    onChanged?.()
  }

  return (
    <Card className="border-0 shadow-sm">
      <CardBody className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h5 className="mb-0 fw-semibold">Pre-Orders</h5>
            <div>Total: {preOrders.length}</div>
          </div>

          <div className="d-flex gap-2">
            <Button
              size="sm"
              color="outline-primary"
              onClick={() =>
                navigate(`/pre-orders/create?cuid=${customer?.cuid ?? ""}`, {
                  state: { from: location },
                })
              }
              className="d-flex align-items-center"
            >
              <i className="bx bx-plus me-1"></i>
              Add Pre-Order
            </Button>
          </div>
        </div>

        <PreOrderList
          data={preOrders}
          customer={customer}
          onChanged={handleChanged}
        />
      </CardBody>
    </Card>
  )
}
